export default function getTitle(href) {
  if (href.includes('/services')) {
    let parts = href.split('/');
    if (parts.length > 2) {
      return `24hrdoc: ${parts[3].split(/(?=[A-Z])/).join(' ')}`;
    } else return `24hrdoc: ${parts[1]}`;
  } else if (href == '/') return '24hrdoc: Home page';
  else {
    let parts = href.split('/');
    return `24hrdoc: ${parts[1]}`;
  }
}
